// Works on the API row after field mapping, without changing the editor draft.
export function normalizeActivationPayload(row, fields) {
  if (!row || typeof row !== "object" || Array.isArray(row)) return row;
  const keys = fields || (
    Object.prototype.hasOwnProperty.call(row, "ActivationMode")
      ? { mode: "ActivationMode", value: "ActivationOffsetValue", unit: "ActivationOffsetUnit" }
      : { mode: "activationMode", value: "activationOffsetValue", unit: "activationOffsetUnit" }
  );
  if (!Object.prototype.hasOwnProperty.call(row, keys.mode)) return row;
  const result = { ...row };
  const mode = String(row[keys.mode] || "").trim().toLowerCase();
  if (mode !== "offset" && mode !== "delayed") {
    result[keys.value] = null;
    result[keys.unit] = null;
    return result;
  }
  const rawValue = row[keys.value];
  const value = typeof rawValue === "number" || typeof rawValue === "string" ? Number(rawValue) : NaN;
  if (!Number.isFinite(value) || value <= 0) {
    throw new Error("Der Aktivierungsversatz muss eine positive Zahl sein.");
  }
  const unit = String(row[keys.unit] || "").trim().toLowerCase().replace(/s$/, "");
  if (!["minute", "hour", "day", "week", "month", "year"].includes(unit)) {
    throw new Error("Bitte wählen Sie eine gültige Einheit für den Aktivierungsversatz (minute, hour, day, week, month, year).");
  }
  result[keys.value] = value;
  result[keys.unit] = unit;
  return result;
}
